var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-col"},[_c('CookieConsentBanner'),_vm._v(" "),_c('FavoritesSidebar'),_vm._v(" "),_c('div',{staticClass:"min-h-screen"},[_c('MainNavigationDesktop'),_vm._v(" "),_c('MainNavigationMobile'),_vm._v(" "),_c('Nuxt',{staticClass:"flex-1"})],1),_vm._v(" "),_c('FooterNavigation'),_vm._v(" "),_c('ToTopButton')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }